













<div class="section">
    <div class="container">
        <nav class="navbar navbar-light">
            <a class="navbar-brand">
                {{#if logo_path}}
                    <img class="img-fluid" src="{{logo_path}}" width="110px" alt="Video Feed Logo" />
                {{/if}}
            </a>
            <div class="right">
                {{#if show_call_to_action}}
                    <a href="{{call_to_action_url}}" target="_blank" id="hero-btn" class="btn navbar-btn">{{call_to_action_text}}</a>
                {{/if}}
            </div>
        </nav>
    </div>
</div>



<section class="section__video-feed">
    <div class="sidebar-container">
        <div id="mySidebar" class="sidebar">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12 sidebar-menu">
                        <a href="#" class="closebtn">Save & Close</a>
                        <a href="#" class="clearbtn">Clear filters</a>
                    </div>
                </div>
            </div>
            <div class="container-fluid filter-sidebar-container">
                {{#each tags}}
                    <div class="col-12">
                        <div class="tag-type-card" data-tagTypeUuid="{{{uuid}}}">
                            <h5>{{{tag_type_name}}}</h5>
                            {{#each tags_collection}}
                                {{#ifCond @key "<=" 3}}
                                    <div class="tag" data-tagUuid="{{{uuid}}}">
                                        <label class="round-check small">
                                            <input class="checkbox tag-input" type="checkbox" name="tag[]" value="{{{uuid}}}" />
                                            <span class="checkmark"></span>
                                            <span>{{{tag_name}}}</span>
                                            {{#if usage_count}}
                                                <span class="tag-usage">({{{usage_count}}})</span>
                                            {{else}}
                                                <span class="tag-usage">(0)</span>
                                            {{/if}}
                                        </label>
                                    </div>
                                {{else ifCond @key ">" 3}}
                                    <div class="tag toggleable" data-tagUuid="{{{uuid}}}">
                                        <label class="round-check small">
                                            <input class="checkbox" type="checkbox" name="tag[]" value="{{{uuid}}}" />
                                            <span class="checkmark"></span>
                                            <span>{{{tag_name}}}</span>
                                            {{#if usage_count}}
                                                <span class="tag-usage">({{{usage_count}}})</span>
                                            {{else}}
                                                <span class="tag-usage">(0)</span>
                                            {{/if}}
                                        </label>
                                    </div>
                                {{/ifCond}}
                                {{#if @last}}
                                    {{#ifCond @key '>' 3}}
                                    <a href="javascript:void(0)" class="show-more">
                                        <span>Show More</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7">
                                            <g fill="none" fill-rule="evenodd">
                                                <g class="svg-color" fill="#98A7AD">
                                                    <g>
                                                        <g>
                                                            <g>
                                                                <path d="M5.895 1L3.54 3.188 1.149 1 0 2.076 3.54 5.375 7 2.076z" transform="translate(-1092 -245) translate(514 154) translate(0 70) translate(578 21)"/>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </a>
                                    {{/ifCond}}
                                {{/if}}            
                            {{/each}}
                        </div>
                    </div>
                {{/each}}
            </div>
        </div>
        <div class="tint-overlay"></div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="banner {{#if banner_path}}active{{/if}}" {{#if banner_path}}style="background-image:url('{{banner_path}}')"{{/if}}>
                    {{#if show_banner_tint}}
                    <div class="banner-overlay"></div>
                    {{/if}}
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                {{#if header_text}}
                                <h4 class="banner-heading">{{{header_text}}}</h4>
                                {{/if}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="row">
            <div class="col-xl-12 sidebar-nav">
                <div id="main">
                    <button id="openbtn">
                        <svg width="14px" height="15px" viewBox="0 0 14 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g class="svg-color" transform="translate(-34.000000, -169.000000)" stroke="#1F9999">
                                    <g id="Group-2" transform="translate(22.000000, 161.000000)">
                                        <g id="Group" transform="translate(12.000000, 8.000000)">
                                            <line x1="0.5" y1="7.5" x2="13.5" y2="7.5" id="Line" stroke-linecap="round"></line>
                                            <line x1="0.5" y1="2.5" x2="13.5" y2="2.5" id="Line-Copy" stroke-linecap="round"></line>
                                            <line x1="0.5" y1="12.5" x2="13.5" y2="12.5" id="Line-Copy-2" stroke-linecap="round"></line>
                                            <circle id="Oval" fill="#FFFFFF" cx="2.5" cy="2.5" r="2"></circle>
                                            <circle id="Oval-Copy" fill="#FFFFFF" cx="11.5" cy="12.5" r="2"></circle>
                                            <circle id="Oval-Copy-2" fill="#FFFFFF" cx="7.5" cy="7.5" r="2"></circle>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                        <span>Filter</span>
                    </button>  
                </div>
            </div>
                <div class="col-xl-3 col-12 filter-column">
                    {{#each tags}}
                        
                    <div class="tag-type-card" data-tagTypeUuid="{{{uuid}}}">
                        <h5>{{{tag_type_name}}}</h5>
                        {{#each tags_collection}}
                            {{#ifCond @key "<=" 3}}
                                <div class="tag" data-tagUuid="{{{uuid}}}">
                                    <label class="round-check small">
                                        <input class="checkbox tag-input" type="checkbox" name="tag[]" value="{{{uuid}}}" data-tagTypeUuid="{{{../uuid}}}" />
                                        <span class="checkmark"></span>
                                        <span>{{{tag_name}}}</span>
                                        {{#if usage_count}}
                                            <span class="tag-usage">({{{usage_count}}})</span>
                                        {{else}}
                                            <span class="tag-usage">(0)</span>
                                        {{/if}}
                                    </label>
                                </div>
                            {{else ifCond @key ">" 3}}
                                <div class="tag toggleable" data-tagUuid="{{{uuid}}}">
                                    <label class="round-check small">
                                        <input class="checkbox tag-input" type="checkbox" name="tag[]" value="{{{uuid}}}" />
                                        <span class="checkmark"></span>
                                        <span>{{{tag_name}}}</span>
                                        {{#if usage_count}}
                                            <span class="tag-usage">({{{usage_count}}})</span>
                                        {{else}}
                                            <span class="tag-usage">(0)</span>
                                        {{/if}}
                                    </label>
                                </div>
                            {{/ifCond}}
                            {{#if @last}}
                                {{#ifCond @key '>' 3}}
                                <a href="javascript:void(0)" class="show-more">
                                    <span>Show More</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7">
                                        <g fill="none" fill-rule="evenodd">
                                            <g class="svg-color" fill="#98A7AD">
                                                <g>
                                                    <g>
                                                        <g>
                                                            <path d="M5.895 1L3.54 3.188 1.149 1 0 2.076 3.54 5.375 7 2.076z" transform="translate(-1092 -245) translate(514 154) translate(0 70) translate(578 21)"/>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </a>
                                {{/ifCond}}
                            {{/if}}            
                        {{/each}}
                    </div>
                        
                    {{/each}}
                

                </div>

                <div class="col-xl-9 col-12 video-item-column">
                    <div class="row" id="isotope-grid-target">
                        {{#each videos}}
                            <div class="video-item col-xxl-3 col-xl-4 col-lg-4 col-md-12 col-12 {{tagClasses}}">
                            <div class="video-item-card">
                                <a href="#" class="video-modal-link" 
                                    data-id="{{id}}" >
                                    <h5>{{{video_title}}}</h5>
                                    <img class="img-fluid thumbnail" data-gifsrc="{{autoplay_gif_link}}" data-thumbnailsrc="{{thumbnail_link}}" src="{{thumbnail_link}}" />
                                    <div class="video-item-details">
                                        <div class="user">
                                            {{#if user.first_name}}
                                            <img class="img-fluid user-profile-picture" src="{{user.image}}" />
                                            <div class="user-info">
                                                <p class="username">{{{user.first_name}}} {{{user.last_name}}}</p>
                                                <p class="role">{{{user.job_title}}}</p>
                                            </div>
                                            {{/if}}
                                        </div>
                                        <div class="tag-video-container">
                                            <div class="tag-container">
                                            {{#each rendered_tags}}
                                                {{#if @first}}
                                                    <div class="tags-container">
                                                {{/if}}
                                                        <div class="tag">
                                                            <span>{{{tag_name}}}</span>
                                                        </div>
                                                {{#if @last}}
                                                    </div>
                                                {{/if}}
                                            {{/each}}
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        {{/each}}
                    </div>
                </div>
            </div>
    </div>
</section>
<!-- Modal -->
<div class="video-modal modal fade" id="videoPlayerModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header justify-content-end align-items-center">
                {{#if show_share_link}}
                <div class="dropdown">
                    <a class="btn btn-sm dropdown-toggle" type="button" data-toggle="dropdown" data-display="static" aria-expanded="false">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.74196 12.0466C5.16118 12.6932 0 15.2799 0 15.2799C0 15.2799 2.08745 7.59596 11.7647 6.94938V1.25L20 9.45985L11.7647 17.9551V11.4696C11.7647 11.4696 10.3227 11.4 7.74196 12.0466Z" fill="white"/>
                        </svg>
                    </a>
                    
                    <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item js-share-LI" href="#">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <g clip-path="url(#clip0_2761_25186)">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M20 18C20 19.104 19.104 20 18 20H2C0.896 20 0 19.104 0 18V2C0 0.896 0.896 0 2 0H18C19.104 0 20 0.896 20 2V18Z" fill="#007EBB"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.2223 17.2223H14.2544V12.1673C14.2544 10.7814 13.7278 10.0069 12.6308 10.0069C11.4374 10.0069 10.814 10.8129 10.814 12.1673V17.2223H7.95376V7.59265H10.814V8.88976C10.814 8.88976 11.674 7.29845 13.7174 7.29845C15.76 7.29845 17.2223 8.54574 17.2223 11.1254V17.2223ZM4.54154 6.33172C3.56729 6.33172 2.77783 5.53607 2.77783 4.55478C2.77783 3.57349 3.56729 2.77783 4.54154 2.77783C5.51579 2.77783 6.30478 3.57349 6.30478 4.55478C6.30478 5.53607 5.51579 6.33172 4.54154 6.33172ZM3.06465 17.2223H6.04711V7.59265H3.06465V17.2223Z" fill="white"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_2761_25186">
                                <rect width="20" height="20" fill="white"/>
                                </clipPath>
                            </defs>
                            </svg>
                            <span>LinkedIn</span>
                        </a>
                        <a class="dropdown-item js-share-FB" href="#">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M2.125 20C1 20 0 19 0 17.875V2.125C0 1 1 0 2.125 0H17.875C19 0 20 1 20 2.125V17.875C20 19 19 20 17.875 20H2.125Z" fill="#3B5998"/>
                            <path d="M14 20V12.125H16.75L17.125 9.125H14V7.125C14 6.25 14.25 5.625 15.5 5.625H17.125V3C16.875 3 15.875 2.875 14.75 2.875C12.5 2.875 10.875 4.25 10.875 6.875V9.125H8.25V12.125H11V20H14Z" fill="white"/>
                            </svg>
                            <span>Facebook</span>
                        </a>
                        <a class="dropdown-item js-copy-video-url" href="#">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.2813 1.25C11.8594 1.25 10.4375 1.79688 9.45313 2.89062L8.14063 4.09375C7.70313 4.53125 7.70313 5.1875 8.14063 5.625C8.57813 6.0625 9.23438 6.0625 9.67188 5.625L10.9844 4.3125C12.1875 3.10937 14.375 3.10937 15.5781 4.3125C16.2344 4.96875 16.5625 5.84375 16.5625 6.71875C16.5625 7.59375 16.2344 8.46875 15.5781 9.01562L14.375 10.3281C13.9375 10.7656 13.9375 11.4219 14.375 11.8594C14.5938 12.0781 14.9219 12.1875 15.1406 12.1875C15.3594 12.1875 15.6875 12.0781 15.9063 11.8594L17.2188 10.5469C18.2031 9.5625 18.75 8.14062 18.75 6.71875C18.75 5.29688 18.2031 3.875 17.1094 2.89062C16.125 1.79688 14.7031 1.25 13.2813 1.25ZM10.3281 14.375L9.01562 15.6875C7.8125 16.8906 5.625 16.8906 4.42188 15.6875C3.76562 15.0312 3.4375 14.1562 3.4375 13.2812C3.4375 12.4062 3.76562 11.5312 4.42188 10.9844L5.625 9.67188C6.0625 9.23438 6.0625 8.57812 5.625 8.14062C5.1875 7.70312 4.53125 7.70312 4.09375 8.14062L2.89062 9.45312C1.79688 10.4375 1.25 11.8594 1.25 13.2812C1.25 14.7031 1.79688 16.125 2.89062 17.1094C3.875 18.2031 5.29688 18.75 6.71875 18.75C8.14062 18.75 9.5625 18.2031 10.5469 17.1094L11.8594 15.7969C12.2969 15.3594 12.2969 14.7031 11.8594 14.2656C11.4219 13.8281 10.7656 13.9375 10.3281 14.375ZM6.93751 11.5312L11.5313 6.93747C11.9688 6.49997 12.625 6.49997 13.0625 6.93747C13.5 7.37497 13.5 8.03122 13.0625 8.46872L8.46876 13.0625C8.25001 13.2812 7.92188 13.3906 7.70313 13.3906C7.48438 13.3906 7.15626 13.2812 6.93751 13.0625C6.50001 12.625 6.50001 11.9687 6.93751 11.5312Z" fill="#36AFCC"/>
                            </svg>
                            <span>Copy Link</span>
                        </a>
                    </div>

                </div>
                {{/if}}
                <a type="button" class="btn btn-sm" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </a>
            </div>
            <div class="modal-body">
                <div class="video-container embed-responsive embed-responsive-16by9">
                    <video id="modal-player" class="video-js"></video>
                </div>
                <div class="video-info-container">
                    <h4></h4>
                    <div class="user">
                        <img class="user-profile-picture" src="">
                        <div class="user-info">
                            <p class="username"></p>
                            <p class="role"></p>
                        </div>
                    </div>
                    <div class="description">
                        <p class="video-description"></p>
                        <a class="btn learn-more-btn" href="#" target="_blank"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Feedback Modal -->
<div class="feedback-modal modal fade" id="feedbackModal" tabindex="-1" aria-labelledby="feedbackModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <div class="satisfied-feedback">
                    <h4 class="text-center px-5">Did you enjoy hearing these employee stories?</h4>
                    <div class="feedback">
                        <div class="feedback-response" data-feedback="No">
                            <div class="icon">
                                <svg width="49" height="49" xmlns="http://www.w3.org/2000/svg">
                                    <g fill="none" fill-rule="evenodd">
                                        <circle fill="#FFF" cx="24.5" cy="24.5" r="24.5"/>
                                        <circle cx="24.5" cy="24.5" r="24.5" fill="#F66"/>
                                        <path d="M32.36 35.341a1.176 1.176 0 1 0 1.653-1.673c-1.828-1.807-6.135-3.062-9.683-3.062-3.543 0-7.836 1.254-9.665 3.062a1.176 1.176 0 0 0 1.654 1.673c1.312-1.296 5.028-2.382 8.011-2.382 2.987 0 6.72 1.087 8.03 2.382z" fill="#FFF" fill-rule="nonzero"/>
                                        <rect fill="#FFF" x="15" y="15" width="3" height="8" rx="1"/>
                                        <rect fill="#FFF" x="31" y="15" width="3" height="8" rx="1"/>
                                    </g>
                                </svg>
                            </div>
                            <h6 class="text-center">No</h6>
                        </div>
                        <div class="feedback-response" data-feedback="Yes">
                            <div class="icon">
                                <svg width="49" height="49" xmlns="http://www.w3.org/2000/svg">
                                    <g fill="none" fill-rule="evenodd">
                                        <circle fill="#FFF" cx="24.5" cy="24.5" r="24.5"/>
                                        <circle cx="24.5" cy="24.5" r="24.5" fill="#63C951"/>
                                        <path d="M32.36 30.946a1.176 1.176 0 1 1 1.653 1.673c-1.828 1.807-6.135 3.062-9.683 3.062-3.543 0-7.836-1.254-9.665-3.062a1.176 1.176 0 0 1 1.654-1.673c1.312 1.296 5.028 2.382 8.011 2.382 2.987 0 6.72-1.087 8.03-2.382z" fill="#FFF" fill-rule="nonzero"/>
                                        <rect fill="#FFF" x="15" y="15" width="3" height="8" rx="1"/>
                                        <rect fill="#FFF" x="31" y="15" width="3" height="8" rx="1"/>
                                    </g>
                                </svg>                                
                            </div>
                            <h6 class="text-center">Yes</h6>
                        </div>
                    </div>
                    <div class="dismiss-btn-container">
                        <button data-dismiss="modal">No Thanks</button>
                    </div>
                </div>
                <div class="feedback-form-container hide">
                    <div class="feedback-form">
                        <div class="feedback-input-container">
                            <h6>What did you like about hearing these employee stories?</h6>
                            <textarea id="feedback" placeholder="Tell us what you liked..."></textarea>
                        </div>
                        <div class="feedback-input-container">
                            <h6>What best describes you?</h6>
                            <div class="feedback-input">
                                <div class="input-container">
                                    <input type="radio" id="job" name="user_description" value="job" />
                                    <label for="job">I'm looking for a job</label>
                                </div>
                                <div class="input-container">
                                    <input type="radio" id="work" name="user_description" value="work" />
                                    <label for="work">I currently work here</label>
                                </div>
                                <div class="input-container">
                                    <input type="radio" id="other" name="user_description" value="other" />
                                    <label for="other">Other</label>
                                </div>
                                <input class="hide" id="other-user" type="text" placeholder="e.g Just looking">
                            </div>
                        </div>
                        <div class="feedback-button-container">
                            <button id="submit-feedback" class="btn btn-primary" disabled="disabled" data-dismiss="modal">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <a href="https://videomyjob.com/?utm_source=widfbpow&utm_medium=website&utm_campaign=custwidg&utm_id={{widget_code}}" target="_blank">
                    <img src="{{cdn}}video-widget/assets/img/powered_by_vmj.png" alt="Powered By VideoMy" style="width:134px;height:18px;" />
                </a>
            </div>
        </div>
    </div>
</div>